export default __webpack_public_path__ + "static/media/splitConduits3.b262a174.jpg";